{"switchLanguage":"言語を切り替える","current":"現在の言語"}